export default {"src":"/_next/static/media/infrastructure-small.440408b3.svg","height":1000,"width":1200,"blurWidth":0,"blurHeight":0};